// Pila de scopes de atajos de teclado. Solo el scope en el tope de la pila
// recibe eventos: así un modal que registra su propio scope al abrirse
// inhibe automáticamente los atajos de la pantalla que lo contiene, sin que
// ninguno de los dos necesite conocer al otro.
const scopes = []
let listenerInstalled = false

function normalizeKey(key) {
  return String(key || '').trim()
}

function matchesBinding(event, binding) {
  if (normalizeKey(event.key).toLowerCase() !== normalizeKey(binding.key).toLowerCase()) return false
  if (event.ctrlKey !== Boolean(binding.ctrlKey)) return false
  if (event.altKey !== Boolean(binding.altKey)) return false
  if (event.metaKey !== Boolean(binding.metaKey)) return false
  return true
}

function resolveEnabled(binding) {
  return typeof binding.enabled === 'function' ? Boolean(binding.enabled()) : true
}

function handleKeydown(event) {
  if (event.repeat) return

  const scope = scopes[scopes.length - 1]
  if (!scope) return
  if (typeof scope.isActive === 'function' && !scope.isActive()) return

  const binding = (scope.bindings || []).find((b) => matchesBinding(event, b))
  if (!binding) return
  if (!resolveEnabled(binding)) return

  event.preventDefault()
  binding.run(event)
}

function installListenerIfNeeded() {
  if (listenerInstalled) return
  window.addEventListener('keydown', handleKeydown)
  listenerInstalled = true
}

function uninstallListenerIfIdle() {
  if (listenerInstalled && scopes.length === 0) {
    window.removeEventListener('keydown', handleKeydown)
    listenerInstalled = false
  }
}

/**
 * Registra un scope de atajos. Devuelve la función de baja (unregister).
 * @param {{ scopeId: string, isActive?: () => boolean, bindings: Array<{
 *   key: string, run: (event: KeyboardEvent) => void, label?: string | (() => string),
 *   enabled?: () => boolean, ctrlKey?: boolean, altKey?: boolean, metaKey?: boolean
 * }> }} params
 */
function register({ scopeId, isActive = () => true, bindings = [] } = {}) {
  if (!scopeId) {
    throw new Error('keyboardShortcutService.register requiere scopeId')
  }

  const scope = { scopeId, isActive, bindings }
  scopes.push(scope)
  installListenerIfNeeded()

  return function unregister() {
    const index = scopes.indexOf(scope)
    if (index !== -1) scopes.splice(index, 1)
    uninstallListenerIfIdle()
  }
}

/**
 * Devuelve los bindings actualmente accionables del scope indicado, solo si
 * ese scope está en el tope de la pila y activo. Pensado para alimentar
 * barras de hints reactivas: se llama desde un `computed` y Vue rastrea las
 * dependencias reactivas leídas por `isActive()`/`enabled()` aunque se
 * invoquen en este frame de función distinto.
 */
function getActiveBindings(scopeId) {
  const topScope = scopes[scopes.length - 1]
  if (!topScope || topScope.scopeId !== scopeId) return []
  if (typeof topScope.isActive === 'function' && !topScope.isActive()) return []

  return (topScope.bindings || [])
    .filter((binding) => resolveEnabled(binding))
    .map((binding) => ({
      key: binding.key,
      label: typeof binding.label === 'function' ? binding.label() : (binding.label || '')
    }))
}

export default {
  register,
  getActiveBindings
}
